angular.module('bmsApp.crm.customer').controller('CustomerMapCtrl', function ($scope,
																			  $q,
																			  $timeout,
																			  $state,
																			  $filter,
																			  CustomerSvc,
																			  CustomerGroupSvc,
																			  uiGmapGoogleMapApi,
																			  uiGmapIsReady) {

	$scope.loading = true;
	$scope.siteMarkers = [];
	$scope.selectedMarker = null;
	$scope.customers = [];
	$scope.markers = {
		events: {
			click: function (evt) {
				$scope.selectedMarker = evt.model;

				$scope.windowOptions.show = !$scope.windowOptions.show;
				// find clicked customer
				var siteId = evt.model.id;
				var customers = $filter('filter')($scope.customers, {
					primary_site: {
						id: siteId
					}
				}, true);

				angular.extend($scope.selectedMarker, {
					customer: customers[0]
				});

				console.log($scope.selectedMarker);

				if (angular.isArray(customers)) {
					angular.forEach(customers, function (customer) {
						$scope.recordClick(customer);
					});
				}
			}
		}
	};
	$scope.viewType = {
		ADVERTISING_GROUP: 1,
		CUSTOMER_INDEX: 2
	};

	$scope.windowOptions = {
		show: false
	};

	$scope.view = $state.is('main.marketing.customerGroupIndex.map') ? $scope.viewType.ADVERTISING_GROUP : $scope.viewType.CUSTOMER_INDEX;

	var params = {};
	if ($scope.view == $scope.viewType.ADVERTISING_GROUP) {
		params = {
			filter: {
				customerGroup: $state.params.id
			}
		};

		CustomerGroupSvc.read($state.params.id)
			.then(function (response) {
				$scope.customerGroup = response.data.customer_group;
			});

	}
	else if ($scope.view == $scope.viewType.CUSTOMER_INDEX) {
		if (angular.isDefined($state.params.id)) {
			params = {
				filter: {
					customer: $state.params.id
				}
			};
		}
		else {
			params = {
				filter: $.deparam($state.params.params)
			};
		}
	}

	$scope.control = {};
	uiGmapIsReady.promise().then(function () {
		CustomerSvc.index(params)
			.then(function (response) {
				var customers = response.data.customer_collection;
				var bounds = new google.maps.LatLngBounds();
				// Put the markers into a custom object for google maps
				angular.forEach(customers, function (customer) {
					if (angular.isObject(customer.primary_site) && angular.isNumber(customer.primary_site.lat) && angular.isNumber(customer.primary_site.lng)) {
						$scope.siteMarkers.push({
							id: customer.primary_site.id,
							geo: {
								latitude: customer.primary_site.lat,
								longitude: customer.primary_site.lng
							}
						});
						var point = new google.maps.LatLng(customer.primary_site.lat, customer.primary_site.lng);
						bounds.extend(point);
						customer.geocoded = true;
					}
					else {
						customer.geocoded = false;
					}
					$scope.customers.push(angular.copy(customer));
				});

				$scope.control.getGMap().fitBounds(bounds);
				$scope.loading = false;
			});

		$scope.recordBlur = function (record) {
			record.selected = false;
		};

		$scope.recordClick = function (record) {
			// deselect all
			angular.forEach($scope.customers, function (value) {
				$scope.recordBlur(value);
			});
			// select this
			record.selected = true;
			// find and move to marker
			var markers = $filter('filter')($scope.siteMarkers, {
				id: record.primary_site.id
			}, true);

			var customers = $filter('filter')($scope.customers, {
				primary_site: {
					id: markers[0].id
				}
			}, true);

			$scope.selectedMarker = angular.extend({}, markers[0], {
				customer: customers[0]
			}) ;

			//
			//angular.extend(self.selectedMarker, angular.extend(markers[0], {
			//	customer: customers[0]
			//}));
			//
			//console.log(self.selectedMarker);

			if (angular.isArray(markers)) {
				angular.forEach(markers, function (marker) {
					var point = new google.maps.LatLng(marker.geo.latitude, marker.geo.longitude);
					var map = $scope.control.getGMap();
					map.panTo(point);
				});
			}
		};
	});

	uiGmapGoogleMapApi.then(function (map) {
		$scope.map = {
			center: {
				latitude: 52,
				longitude: -1.0
			},
			zoom: 8,
			options: {
				panControlOptions: {
					position: map.ControlPosition.RIGHT_TOP
				},
				zoomControlOptions: {
					position: map.ControlPosition.RIGHT_TOP
				},
				mapTypeControlOptions: {
					position: map.ControlPosition.RIGHT_BOTTOM
				}
			},
			events: {
				//tilesloaded: function (map) {
				//    $scope.$apply(function () {
				//        //console.log('this is the map instance', map);
				//    });
				//}
			}
		};
	});

});
